<template>
  <section class='section login-container'>
    <div class='box login-form'>

      <form @submit.prevent="submit">
        <b-field label="Email" custom-class="content">
          <b-input type="email" v-model="email" />
        </b-field>

        <b-field label="Password" custom-class="content">
          <b-input type="password" v-model="password" />
        </b-field>
        <div class="buttons-container">
          <button class="button is-primary" type="submit">
            Login
          </button>
          <router-link class="button is-danger" :to="{name:'forgot-password'}">
            Forgot your password?
          </router-link>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    ...mapActions({
      initializeUser: 'auth/initializeUser',
    }),
    async submit() {
      let tokens;
      try {
        tokens = (await this.$http.post('/users/token/', { email: this.email, password: this.password })).data;
      } catch (e) {
        this.$toast.open({
          message: 'Cannot login with the provided credentials',
          type: 'is-danger',
        });
        return;
      }
      await this.initializeUser(tokens);

      const { redirect } = this.$route.query;
      if (redirect) {
        this.$router.replace({ path: redirect });
      } else {
        this.$router.replace({ path: '/' });
      }
    },
  },
};
</script>


<style lang="scss" scoped>

.login-form {
  min-width: 30vw;
  max-width: 480px;
}

.login-container {
  display: flex;
  justify-content: center;
}

.buttons-container {
  display: flex;
  justify-content: space-between;
}
</style>
